import {Button} from '@/components/ui/button/Button'
import styled, {css} from 'styled-components'

export const StyledButton = styled(Button)(
    ({theme: {palette}}) => css`
        &.active {
            background-color: ${palette.primary[50]};
            color: ${palette.primary[500]};
            outline-color: ${palette.primary[500]};
        }
    `
)
